module.exports = __webpack_public_path__ + "media/images/bbq-0c782b6f7edc2b267f14e79b7c1ce526.png";